import {
  FETCH_ALL_CAMPAIGNS,
  FETCH_ALL_CAMPAIGNS_SUCCEDD,
  FETCH_ALL_CAMPAIGNS_FAILED,
} from '../actions/campaign/action_types';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_ALL_CAMPAIGNS_SUCCEDD:
      return {
        ...state,
        campaign: action.params.data,
      };
    default: {
      return {
        ...state,
      };
    }
  }
};
